import firebase from "firebase/app";
// import firestore from 'firebase/firestore'
import "firebase/firestore";
import "firebase/functions";
import "firebase/auth";

// Initialize Firebase

var config = {
  apiKey: "AIzaSyAmBH6rjwBHJKxpi9cQ3-sR4e-PaBaXTd8",
  authDomain: "everowl-technologies.firebaseapp.com",
  databaseURL: "https://everowl-technologies.firebaseio.com",
  projectId: "everowl-technologies",
  storageBucket: "everowl-technologies.appspot.com",
  messagingSenderId: "576772456936",
};

const firebaseApp = firebase.initializeApp(config);
// firebaseApp.firestore().settings({ timestampsInSnapshots: true })
// firebaseApp.functions()

// export firestore database

export default firebaseApp.firestore();
